import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

const HouseSearchResultsCardSkeletonCard = () => {
  return (
    <div className={s.skeletonCard}>
      <div className={clsx(s.skeletonImage)} />
      <div className={s.skeletonContent}>
        <div className={s.skeletonUpLeftContainer}>
          <div
            style={{ width: '200px' }}
            className={clsx(s.skeletonCardSubTitle)}
          />
          <div
            style={{ width: '240px' }}
            className={clsx(s.skeletonCardSubTitle, s.tall)}
          />
          <div
            style={{ width: '140px' }}
            className={clsx(s.skeletonCardSubTitle)}
          />
        </div>
        <div className={s.skeletonDownRightContainer}>
          <div
            style={{ width: '70px' }}
            className={clsx(s.skeletonCardSubTitle)}
          />
          <div
            style={{ width: '150px' }}
            className={clsx(s.skeletonCardSubTitle, s.tall)}
          />
          <div
            style={{ width: '80px' }}
            className={clsx(s.skeletonCardSubTitle)}
          />
          <div
            style={{ width: '140px' }}
            className={clsx(s.skeletonCardSubTitle, s.veryTall)}
          />
        </div>
      </div>
    </div>
  )
}

export default HouseSearchResultsCardSkeletonCard
